<template>
  <div tabindex="0" class="smart rating flex" @focus="prev = value" @blur="disabled ? null : onBlur()" @mouseleave.self="showPreview = false" @mouseenter="showPreview = true; previewValue = currentValue">
    <div v-for="i in count" :key="i" :icon="getIcon(i)" @mousedown.self.stop="disabled ? null : onRatingChange($event, i)" @mousemove.self.stop="disabled ? null : onRatingChange($event, i)">
      <smart-icon :icon="getIcon(i)"></smart-icon>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'ratingPanel',
  props:{
      value: {
          type: Number,
          default: 0
      },
      count: {
          type: Number,
          default: 5
      },
      disabled: {
          type: Boolean,
          default: false
      },
      iconEmpty:{
        type: String,
        default: 'rating_empty.svg'
      },
      iconHalf:{
        type: String,
        default: 'rating_half.svg'
      },
      iconFull:{
        type: String,
        default: 'rating_full.svg'
      },
      previewMode:{
        type: Boolean,
        default: true
      }
  },
  data(){
    return {
      prev: null,
      showPreview: false,
      currentValue: 0,
      previewValue: 0,
    };
  },
  watch:{
    value(newValue){
      this.currentValue = newValue;
    }
  },
  methods:{
    getIcon(i){
      var value = !this.disabled && this.previewMode && this.showPreview ? this.previewValue : this.currentValue;

      if(value >= i)
        return this.iconFull;
      else if(value > (i - 0.6))
        return this.iconHalf;
      return this.iconEmpty;
    },
    setRating(value, previewOnly){
      this.previewValue = value;
      if(previewOnly)
        return false;

      this.currentValue = value;
      this.$emit("input", value);
    },
    onBlur(){
      if(this.prev !== this.currentValue)
        this.$emit('change', this.value)
    },
    onRatingChange: _.throttle(function (event, i){
      var previewOnly = event.buttons !== 1;
      this.setRating(this.getTargetValue(event, i), previewOnly);
    }, 50),
    getTargetValue(event, index){
      var offsetX = event.offsetX/event.target.clientWidth;
      var offset = 0;
      if(index < 2 && offsetX < .25)
        offset = -1;
      else if(offsetX < .5)
        offset = -0.5;
      return index + offset;
    }
  }
}
</script>

<style>
.smart.rating {
  --icon-size: 32px;

  float: left;
  outline: none;
  padding: 4px;
}

.smart.rating > div{
  width: var(--icon-size);
  height: var(--icon-size);
}

.smart.rating svg{
  pointer-events: none;
}
</style>